<template>
  <div id="park_pickup">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- notice -->
      <section>
        <div class="l-main l-main--bg-border--green l-main--bg-border pt-60">
          <div class="l-main__head">
            <div class="l-park-pickup__title-box--title top">
              モバイルオーダー
            </div>
            <div v-if="orders && orders.length && $store.state.unread && $store.state.unread[SHOP_ID]" class="l-header__cart--number history">{{$store.state.unread[SHOP_ID]}}</div>
            <div v-show="orders && orders.length" class="c-btn l-park-pickup__title-box--btn" @click.prevent="$router.push('/mobileorder/history')">注文状況・履歴</div>
          </div>
          <div class="l-park-pickup">
            <div class="l-park-pickup__note l-park-pickup__white title-type mt-16" style="font-size: 16px;">
              事前にオーダーを行い、店舗でピックアップ、もしくは、ドライブスルーでお受け取りできます。
            </div>
            <div class="c-box-regist mb-24" v-if="!isUserOrderable()">
              <p>
                こちらのサービスを利用するには、ログインと本人確認（SMS認証）が必要です。
              </p>
              <router-link to="/account/profile" class="c-btn c-btn--red box-center">ログイン・本人確認はこちら</router-link>
            </div>
            <div class="c-tab-nav c-tab-nav--xl mb-24">
              <div class="c-tab-nav__item is-active">
                受け取り方法
              </div>
            </div>
            <div class="method-list-wrap">
              <div :class="{'d-flex': true, 'method-list': true, 'disabled': !pickupEnabled}" @click.prevent="openStoreList('pickup')">
                <img src="/assets/images/park-pickup-method-bag.svg" alt="">
                <div class="">
                  <p class="mb-8">店内へ取りに行く</p>
                  <div class="d-flex">
                    <div class="handling-format-label togo">お持ち帰り</div>
                    <div class="handling-format-label forhere">店内でお食事</div>
                  </div>
                </div>
              </div>
              <div :class="{'d-flex': true, 'method-list': true, 'disabled': !drivethruEnabled}" @click.prevent="openStoreList('drivethru')" v-if="mobileOrderConfig.drivethruAreaName">
                <img src="/assets/images/park-pickup-method-car.svg" alt="">
                <div class="d-flex">
                  <p>ドライブスルーで<br />受け取る</p>
                </div>
              </div>
              <div :class="{'d-flex': true, 'method-list': true, 'disabled': !parkAndPickupEnabled}" @click.prevent="openStoreList('parkandpickup')" v-if="mobileOrderConfig.parkAndPickupAreaName">
                <img src="/assets/images/park-pickup-method-p.svg" alt="">
                <div class="d-flex">
                  <p>
                    {{mobileOrderConfig.parkAndPickupAreaName}}で受け取る
                  </p>
                </div>
              </div>
            </div>
            <div class="info">
              <div>※利用できるクレジットカードはイオンカードとVISA, Mastercardです。</div>
              <div>※商品提供方法により消費税計算が異なる場合があります</div>
              <div>※商品提供方法がお持ち帰りの場合、容器代等が加わり商品単価が変わる場合があります</div>
              <div>※受け取り方法は途中で変更できません</div>
              <div class="d-flex check-spot" v-if="mobileOrderConfig.drivethruAreaName || mobileOrderConfig.parkAndPickupAreaName">
                <img src="/assets/images/icon/icon-map-marker-alt.svg" alt="">
                場所を確認する
              </div>
              <div class="link">
                <a href="#" @click.prevent="openLocationPopup('drivethru')" v-if="mobileOrderConfig.drivethruAreaName">ドライブスルー</a>
                <a href="#" @click.prevent="openLocationPopup('parkandpickup')" v-if="mobileOrderConfig.parkAndPickupAreaName">{{mobileOrderConfig.parkAndPickupAreaName}}</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <alert :message="alert_msg" 
      :show="alert_show" 
      :closeModal="closeModal" 
      :confirm_show="confirm_show" 
      :confirm_message="confirm_msg" 
      :confirm_callback="confirm_callback" 
      :confirm_hide_cancel="confirm_hide_cancel"
      :label_cancel="confirm_label_cancel"
      :label_ok="confirm_label_ok"
      ></alert>
    <confirm-delivery :callback="confirmCallback" :deliveryMethod="deliveryMethod" :message="confirmDeliveryMessage" :show="confirmDeliveryShow" :subMessage="confirmDeliverySubMessage" :buttonName="continueOrderButtonName" />
    <drive-thru-modal :show="show_drivethru_modal" :onClose="closeLocationPopup" :isMaintenance="is_drivethru_maintenance" />
    <park-and-pickup-modal :show="show_parkandpickup_modal" :onClose="closeLocationPopup" />
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getMobileOrderConfig } from "../store/firestore";
import { getMyOrders } from "../store/firestore";
import PopAlert from "../components/PopAlert.vue";
import Alert from "../components/Alert.vue";
import dayjs from "dayjs";
import ConfirmDelivery from "../components/ConfirmDelivery.vue";
import DriveThruModal from "../components/DriveThruModal.vue";
import ParkAndPickupModal from "../components/ParkAndPickupModal.vue";

export default Vue.extend({
  name: "MobileOrder",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'alert': Alert,
    PopAlert,
    ConfirmDelivery,
    DriveThruModal,
    ParkAndPickupModal
  },
  mixins: [Tenant],
  data() {
    return {
      orders: [],
      mobileOrderConfig: {},
      confirmCallback: null,
      deliveryMethod: null,
      confirmDeliveryMessage: null,
      confirmDeliveryShow: null,
      confirmDeliverySubMessage: null,
      show_drivethru_modal: false,
      show_parkandpickup_modal: false,
      is_pickup_maintenance: false,
      is_drivethru_maintenance: false,
      is_parkandpickup_maintenance: false,
      is_reservation_maintenance: false,
      continueOrderButtonName: "",
    }
  },
  async created(){
    const now = Date.now()
    const mobileOrderConfig = await getMobileOrderConfig(this.shopId);
    this.mobileOrderConfig = mobileOrderConfig;
    //TODO DB取得に変える
    this.is_drivethru_maintenance = now >= dayjs("2021-02-09 00:00:00").valueOf() && now < dayjs("2021-02-22 00:00:00")

    //カートに商品があるかチェック
    const cartData = this.$store.state.cart;
    const carts = Object.values(cartData);
    if (carts.length > 0) {
      const first = carts[0];
      switch (first.handlingFormat) {
        case 1:
        case 2:
          //pickup
          this.$router.replace('/mobileorder/pickup/shop');
          return
        case 3:
          //drivethru
          this.$router.replace('/mobileorder/drivethru/shop');
          return
        case 4:
          //parkandpickup
          this.$router.replace('/mobileorder/parkandpickup/shop');
          return
        case 5:
          //reservation
          //カートクリアする
          await this.$store.dispatch('clearCart');
      }
    }
    const userId = this.$store.state.userId;
    const orders = await getMyOrders(userId)
    this.orders = orders;

    Common.initDom();
  },
  computed: {
    pickupEnabled() {
      return this.isUserOrderable();
    },
    drivethruEnabled() {
      return this.isUserOrderable();
    },
    parkAndPickupEnabled() {
      return this.isUserOrderable();
    }
  },
  methods: {
    openLocationPopup(type) {
      if(type == 'drivethru') {
        this.show_drivethru_modal = true;
      } else {
        this.show_parkandpickup_modal = true;
      }
    },
    closeLocationPopup(type) {
      if(type == 'drivethru') {
        this.show_drivethru_modal = false;
      } else {
        this.show_parkandpickup_modal = false;
      }
    },
    async confirmDelivery(type) {
      return new Promise((resolve, reject) => {
        this.confirmCallback = function() {
          resolve();
        }
        if (type == 'drivethru') {
          if (this.is_drivethru_maintenance) {
            this.deliveryMethod = "ドライブスル―受け取り\n一時中止のお知らせ";
            this.confirmDeliveryMessage = "2/9～2/22までドライブスルーレーン工事中のためご利用いただけません。\n\n恐れ入りますが、他のお受け取り方法をご選択いただきますようお願い申し上げます。";
            this.confirmDeliverySubMessage = "※お車でお受け取りの際は「専用駐車場で受け取る」をご利用ください";
            this.confirmDeliveryShow = true;
            this.continueOrderButtonName = "戻る";
          } else {
            this.deliveryMethod = "ドライブスルーで\n受け取る";
            this.confirmDeliveryMessage = "お受け取りの際は、準備完了の通知が届いてから、ドライブスルーレーンへお越しください。\n\nご注⽂の内容によってはご連絡させていただく場合がございます。";
            this.confirmDeliverySubMessage = "※ドライブスルーレーンにある、ドライブピックアップインターホンは、ネットスーパー専用ですのでご利用いただけません。ご注意ください。";
            this.confirmDeliveryShow = true;
            this.continueOrderButtonName = "";
          }
        } else if (type == 'parkandpickup') {
          this.deliveryMethod = this.mobileOrderConfig.parkAndPickupAreaName+"で受け取る";
          this.confirmDeliveryMessage = `ご利用には、${this.mobileOrderConfig.parkAndPickupAreaName}の駐車番号が必要になります。\n必ず${this.mobileOrderConfig.parkAndPickupAreaName}に車を停めてからご注文ください。\n\nご注⽂の内容によってはご連絡させていただく場合がございます。`;
          this.confirmDeliverySubMessage = "";
          this.confirmDeliveryShow = true;
            this.continueOrderButtonName = "";
        }
      })
    },
    async openStoreList(type) {
      if (this.isUserOrderable()) {
        await this.$store.dispatch('clearCart');
        if (["pickup","drivethru","parkandpickup","reservation"].includes(type)){
          if (type != 'pickup'){
            await this.confirmDelivery(type);
          }
          if (
            (type == 'pickup' && this.is_pickup_maintenance)
            || (type == 'drivethru' && this.is_drivethru_maintenance)
            || (type == 'parkandpickup' && this.is_parkandpickup_maintenance)
            || (type == 'reservation' && this.is_reservation_maintenance)
          ) {
            //nothing
            this.confirmDeliveryShow = false;
            return
          } else {
            this.$router.push(`/mobileorder/${type}/shop`);
          }
        }
      } else {
        this.alert("モバイルオーダーのご利用にはログイン・本人確認が必要です。");
      }
    }
  }
})
</script>